var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import * as React from 'react';
import { styled } from '@creditas-ui/system';
import { Box } from '@creditas-ui/layout';
var InputElement = styled(Box.withComponent('input'))(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  border: none;\n  background: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n"])));
var Input =
/*#__PURE__*/
React.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'input' : _ref$component,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      name = _ref.name,
      id = _ref.id,
      value = _ref.value,
      placeholder = _ref.placeholder,
      className = _ref.className,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "autoFocus", "autoComplete", "component", "disabled", "name", "id", "value", "placeholder", "className", "onChange", "onFocus", "onBlur"]);

  return (
    /*#__PURE__*/
    React.createElement(InputElement, _extends({}, props, {
      ref: ref,
      type: type,
      as: component,
      autoFocus: autoFocus,
      autoComplete: autoComplete,
      disabled: disabled,
      name: name,
      id: id,
      value: value,
      placeholder: placeholder,
      className: className,
      onFocus: onFocus,
      onChange: onChange,
      onBlur: onBlur
    }))
  );
});
export { Input };